import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get currency
export const getCurrency = createAsyncThunk("currency/getCurrency", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getCurrency({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all currency
export const getAllCurrency = createAsyncThunk("currency/getAllCurrency", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllCurrency();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("currency/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("currency/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk("currency/getParticularPage", async (params, { rejectWithValue }) => {
  const { number, rowsPerPage, search } = params;
  try {
    const { data } = await API.getPageCurrency({ number, rowsPerPage: rowsPerPage, search });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get particular page
export const getCurrencyById = createAsyncThunk("currency/getCurrencyById", async (id, { rejectWithValue }) => {
  try {
    const { data } = await API.getCurrencyById(id);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create currency
export const createCurrency = createAsyncThunk("currency/createCurrency", async (param, { rejectWithValue }) => {
  try {
    const body = new FormData();

    Object.entries(param).forEach(([key, value]) => {
      {
        body.append(key, value);
      }
    });
    const { data } = await API.createCurrency(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const updateCurrency = createAsyncThunk("currency/updateCurrency", async (param, { rejectWithValue }) => {
  const { id, values } = param;

  try {
    const body = new FormData();

    Object.entries(values).forEach(([key, value]) => {
      {
        body.append(key, value);
      }
    });
    const { data } = await API.updateCurrency(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("currency/handleSearch", async (data, { rejectWithValue }) => {
  const { search, rowsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
